import styled from 'styled-components';

const Heading = styled.h2`
  color: inherit;
  font-size: 1.6rem;
  font-weight: 600;
  margin-bottom: 3.2rem;
  text-align: center;

  ${({ theme }) => theme.MEDIA.SM} {
    font-size: 2.4rem;
    margin-bottom: 4.8rem;
  }

  ${({ theme }) => theme.MEDIA.LG} {
    font-size: 3.2rem;
    margin-bottom: 8rem;
  }
`;

export default Heading;
